module.exports = __webpack_public_path__ + "static/media/1.70abc32f.png";